import { ProtectedImg } from '../../utils/protectedFile';
import React, { useEffect, Fragment, useState } from 'react';
import { searchOnEnter } from '../../components/searchOnEnter';
import MetaData from '../../layouts/MetaData';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import defaultImg from '../../assets/Images/defaultUser.png';
import { useDispatch, useSelector } from 'react-redux';
import { doctorProfile, 
    getDoctorPatients, 
    removePatientsDoctor, 
    removeHRFromDoctor, 
    getDoctorCCMPatients,
    getDoctorNurses
 } from '../../actions/adminActions';
import folderImg from '../../assets/Images/folder.png';
import Loader from '../../layouts/Loader';
import { useAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import {Badge, Modal, Button, DropdownButton, Dropdown, Table} from 'react-bootstrap';
import { Prod01 } from '../../constants/ActionType';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';
import { formatDate, formatDob } from '../../utils/dateFormat';

const PROVIDER_PATIENT_SORT_COLUMNS = {
    name: { type: 'name', value: personName },
    dob: { type: 'date', value: (p) => p?.DOB },
    status: { type: 'boolean', value: (p) => p?.block },
    provider: { type: 'name', value: (p) => personName(p?.assigned_doctor_id) },
    compliancy: { type: 'number', value: (p) => (p?.assigned_devices || []).length },
    consent: { type: 'string', value: (p) => p?.patientType },
};

const DoctorProfile = (props) => {
    const dispatch = useDispatch();
    const alert = useAlert();

    let docId = props?.location?.state?.id;
    const [smShow, setSmShow] = useState(false); //small confirm modal.
    const [patientName, setPatientName] = useState(""); //patient name to show in modal.
    const [patientToRemove, setpatientToRemove] = useState(""); //set patient id to remove.
    const [doctorId, setDoctorID] = useState(docId); 
    const [query, setQuery] = useState("");
    const [patientType, setPatientType] = useState("RPM");
    const keys = ["firstname", "lastname", "DOB", "email", "phone1", "diseases"];

    const { loading, error: doctorProfileError, doctor } = useSelector(state => state.doctorProfile);
    const { doctorpatients } = useSelector(state => state.docPatients);
    const tableSort = useSortableTable(doctorpatients, { id: 'admin.providerProfile.patients', columns: PROVIDER_PATIENT_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
    const { nursesList } = useSelector(state => state.doctorNurses);
    const {error, message} = useSelector(state => state.common);

    useEffect(() => {
        if(message){
            alert.success(message);
        }
    
        if(error){
            alert.error(error)
        }
        
        dispatch(doctorProfile(doctorId));
        if(patientType === 'RPM'){
            dispatch(getDoctorPatients(doctorId));
        } else {
            dispatch(getDoctorCCMPatients(doctorId));
        }

        dispatch(getDoctorNurses(doctorId));

    }, [dispatch, error, doctorId, message, doctorId, patientType]);


    const removePatient = () => {
        dispatch(removePatientsDoctor(patientToRemove, doctorId));
        setSmShow(false);
    }

    const removeHR = (hrId) => {
        var confirmation = window.confirm(`Are you sure you want to remove nurse from this doctor ?`);
        if(confirmation){
            dispatch(removeHRFromDoctor(hrId, doctorId));
            props.history.push('/doctors');
        }
    }

    const sendEmail = (email) => {
        window.open(`mailto:${email}`)
    }


    return (
        <Fragment>
            <MetaData title= {formatClinicianName(doctor)} />
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />

                
                    {loading ? <Loader /> : <Fragment>
                    <div className="shadow-lg p-3 mb-5 mr-4 ml-4 bg-white rounded">        
                        <div className="home-content">

                        
                        <div className="row-display">
                            <div className="col-md-9">   
                                <h5 className='title'>
                                    <i className="bx bx-user"></i> <strong>&nbsp;Provider Profile </strong>
                                </h5>
                            </div>
                            
                            <div className="row-display">
                                <Button className="btn btn-secondary btn-sm" onClick={() => props.history.goBack()}><i className='bx bx-arrow-back' ></i></Button> &nbsp;
                                    <Link to="/adminDashboard" className="btn btn-secondary btn-sm"><i className='bx bx-home'></i></Link> &nbsp;
                                    <Link to={{ pathname: "/assigndoctor", state: {id: doctor?._id, firstName: doctor?.firstname, lastName: doctor?.lastname, clinicianName: formatClinicianName(doctor)}}} 
                                    className="edit-pill">Assign Patient
                                </Link>
                            </div>                          
                        </div>
                         <hr />

                        
                        <div className="container">
                        {doctor && <Fragment>
                            <div className="row">
                            <div className="col-md-4">
                                <div className="text-center">
                                    {/* <img src={defaultImg} className="profile-img"/> */}
                                    {doctor && doctor?.profileImg ? <>
                                        <ProtectedImg fileName={doctor?.profileImg} 
                                        className="profile-img" alt="profileimg" 
                                    />
                                    </> :  <img src={defaultImg} className="profile-img" alt="profileimg" 
                                    />}

                                    <br/><br/>    
                                    <p className="profile-name m-0 p-0">{formatClinicianName(doctor)} </p>
                                    
                                    <Link to="/doctorProfile" 
                                        className="link text-center m-0 p-0" 
                                        onClick={() => sendEmail(doctor?.email)}><p className="text-center">{doctor?.email}</p>
                                    </Link>

                                    <Link className="edit-pill" to={{ pathname: "/Doctor/Edit", state: {id: doctor}}}>
                                        Edit Profile
                                    </Link>

                                    <p className="profile-name">
                                        {doctor?.specialization}
                                    </p>
                                    {doctor?.practice && <p className="text-muted text-center m-0"><i className="bx bx-buildings"></i> {doctor?.practice}</p>}                                
                                </div>
                            </div>

                            <div className="col-md-8">
                                <div>
                                    <div className="card-inner-margin">
                                        <div className="row">
                                        <div className="col-md-4">

                                            <span className="profile-label">License Number: </span>
                                            <p className="profile-value-text">{doctor?.licensenumber ? doctor?.licensenumber : 'N/A'}</p>
                                            
                                            <span className="profile-label">DOB : </span>
                                                <p className="profile-value-text">{formatDob(doctor.DOB)}</p>

                                                <span className="profile-label">Phone 1: </span>
                                                <p className="profile-value-text">{doctor?.phone1 ? <span style={{color: 'dodgerblue'}}><i className='bx bx-phone'></i> {doctor?.phone1} </span> : 'N/A'}</p>
                                            </div>


                                            <div className="col-md-3" style={{borderRightStyle: 'solid', borderRightWidth: '2px', borderRightColor: '#ccc'}}>
                                                
                                                <span className="profile-label">NPI #: </span>
                                                <p className="profile-value-text">{doctor?.licensenumber}</p>

                                                <span className="profile-label">Mobile No: </span>
                                                <p className="profile-value-text">{doctor?.mobileNo ? <span style={{color: 'dodgerblue'}}><i className='bx bx-phone'></i> {doctor?.mobileNo} </span> : 'N/A'}</p>
                                            
                                                <span className="profile-label">Acc. Created At: </span>
                                                <p className="profile-value-text">{formatDate(doctor?.createdAt)}</p>
                                            </div>

                                            <div className="col-md-5 text-center">
                                            
                                            <h5 style={{color: '#004aad', marginTop: '10px'}}>
                                                <i className="bx bx-user"></i> <strong>&nbsp;Assigned Nurse( s ) </strong>
                                            </h5> 

                                                {nursesList && nursesList.map((nurse, index) => (
                                                    <div key={index} className="nursesList">
                                                        <div className="row-display ml-2 mr-2">
                                                            <span>{nurse?.firstname +"  "+ nurse?.lastname}</span>
                                                            <button className="btn btn-link m-0 p-0" onClick={() => removeHR(nurse?._id)}>
                                                                <i className='bx bx-trash' style={{color: 'red', fontWeight: 'bold'}}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                                {/* {doctor && doctor?.assigned_hr_id?._id ? <>
                                                <hr />
                                                <img src={defaultImg} className="img-responsive profile-card-img"/>
                                                <p className="profile-name">{formatClinicianName(doctor?.assigned_hr_id)} </p>
                                                <p className="profile-value-text" style={{wordWrap: 'break-word'}}>{doctor?.assigned_hr_id?.email}</p>
                                                <button className="btn btn-outline-danger btn-sm" onClick={() => removeHR(doctor?.assigned_hr_id?._id)}>Remove Nurse</button>
                                                </> : <small style={{color: 'gray'}}> <hr /> No HR assigned yet</small>} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>    

                        <hr />
                        {/* paste patients list fragment here */}
                        {doctorpatients && doctorpatients?.length > 0 ? (<Fragment>
                            <div className="row-display">
                            
                            <h5 style={{color: '#004aad', marginTop: '10px'}}>
                                <i className="bx bxs-user-check"></i> 
                                    &nbsp;Assigned Patients <p><small className="text-muted">
                                        Total Assigned Patients are {doctorpatients && doctorpatients.length < 10 ? "Assigned " + patientType +" Patients are : "+ '0'+doctorpatients.length : doctorpatients.length}
                                    </small>
                                </p>
                            </h5>
                               
                            <div className="row-display">
                                
                                <select 
                                value={patientType}
                                onChange={e => setPatientType(e.target.value)}
                                className='form-control mt-2 mr-2'>
                                    <option value="RPM">RPM Patients</option>
                                    <option value="CCM">CCM Patients</option>
                                </select>


                                <input 
                                type="text" 
                                className="form-control mt-2"
                                onChange={e => setQuery(e.target.value)}
                                onKeyDown={searchOnEnter(setQuery)}
                                placeholder="Search"
                                style={{width: '180px', height: '40px'}}
                                /> 

                                &nbsp;&nbsp;&nbsp;
                            </div>
                            </div>
                            <br />

                                <div className="col-md-12">
                                    <Fragment>
                                        <Table responsive className="table table-sm table-striped">
                                        <thead align="center">
                                            <tr>
                                            <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                            <SortableTh sortKey="dob" sort={tableSort}>D.O.B</SortableTh>
                                            <SortableTh sortKey="status" sort={tableSort}>Account Status</SortableTh>
                                            <SortableTh sortKey="provider" sort={tableSort}>Assigned Physician</SortableTh>
                                            <SortableTh sortKey="compliancy" sort={tableSort}>Compliancy Status</SortableTh>
                                            <th>Diseases</th>
                                            <SortableTh sortKey="consent" sort={tableSort}>Consent Role</SortableTh>
                                            <th>Action</th>
                                            </tr> 
                                        </thead>
                                        <tbody>
                                            {tableSort.rows.filter(item => keys.some(key => item[key]?.toLowerCase().includes(query))).map((patient, index) => ( 
                                            <tr align="center" key={index}>

                                        {patient?.block === false ? <td><Link style={{textDecoration: 'none', fontWeight: 'bold', color: '#222'}}
                                                to={{ pathname: "/patientProfile", state: {patientid: patient?._id, deviceid: patient?.deviceassigned?.deviceid}}}>
                                                {patient?.firstname} {patient?.lastname}
                                                <p>{patient?.phone1}</p>  
                                                </Link>
                                            </td> : <td>
                                            {patient?.firstname} {patient?.lastname}
                                                <p>{patient?.phone1}</p>
                                            </td> }

                                            <td> {formatDob(patient?.DOB)} <p><Badge bg="dark text-white">{patient?.gender}</Badge></p></td> 

                                    
                                            {patient?.block === false ? <td>
                                                <Badge pill bg="success text-white" style={{fontSize: '12px', fontWeight: 300}}>Active</Badge>
                                                </td> : <td><Badge pill bg="danger text-white" style={{fontSize: '12px'}}>Inactive</Badge>
                                            </td>}

                                            {patient?.assigned_doctor_id ? <>
                                                <td className="text-nowrap">{formatClinicianName(patient?.assigned_doctor_id)}</td>
                                                </> : <>
                                                <td><Badge bg="danger text-white" className="not-assigned-tag">Not Assigned</Badge></td>
                                            </>}

                                            <td>
                                                {patient?.assigned_devices.length > 0 ? <Badge 
                                                pill bg="success text-white" style={{fontSize: '12px'}}>compliant</Badge> : 
                                                <Badge pill bg="danger text-white" style={{fontSize: '12px'}}>non-compliant</Badge>}
                                            </td>

                                            <td className= 'shrinkText'>{patient?.diseases}</td>

                                            <td>{patient?.patientType}</td>        
                                            <td>
                                            <DropdownButton id="dropdown-basic-button" variant="Light" disabled={patient?.block === true ? true : false}>
                                                <Dropdown.Item>
                                                <Link to={{ pathname: "/patientProfile", state: {patientid: patient?._id}}} className="link">View Profile</Link> &nbsp;

                                                </Dropdown.Item>

                                                <Dropdown.Item>
                                                    <Link to="/doctorProfile" className="link" style={{color: 'red'}} onClick={() => {setSmShow(true); setPatientName(patient?.lastname); setpatientToRemove(patient?._id)}}>Remove from list</Link> &nbsp;
                                                </Dropdown.Item>
                                            </DropdownButton>
                                            </td>
                                        </tr> 
                                        
                                        ))}    
                                        
                                        
                                        </tbody>
                                        </Table>    
                                    </Fragment>                      
                            </div>
                        </Fragment> ) : <Fragment>

                        <div>    
                        <h5 className="pt-2 mt-2">Patient's List </h5> 
                            <hr className="blue-hr"/>
                                           
                                <img src={folderImg} className="no-record-found-img"/>
                                <p className="doctor-specilizations">No Patient Assigned Yet...</p>
                            
                             
                        </div>
                        </Fragment> }               


                        {/* paste patients list fragment here */}
                        </Fragment>}
                        
                        </div>
                    </div>
                    </div>
                    </Fragment>
                    }
            </section>

             <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Body>
                    <small style={{color: '#303030'}}>Are you sure you want to remove patient 
                            <span style={{color: '#303030', fontWeight: 'bold'}}> {patientName}</span> from doctor 
                            <span style={{color: '#303030', fontWeight: 'bold'}}>{formatClinicianName(doctor)} ?
                            </span>
                            
                    </small>
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-sm btn-danger" onClick={removePatient}>Remove</button>
                </Modal.Footer>
             </Modal> 
        </Fragment>
    )
}

export default DoctorProfile
